import { NgModule } from '@angular/core';
import { VideoDisplayComponent } from './video_display.component';


@NgModule({
  imports: [],
  exports: [VideoDisplayComponent],
  declarations: [VideoDisplayComponent],
  providers: [],
})
export class VedioDisplayModule { }
